import { AccountMenuItem } from "@cntrl/ui";
import { useMyInvites } from "../../app/hooks/useMyInvites.js";
import { openPendingInvites } from "../../app/pendingInvitesPanel.js";
import styles from "./PendingInvitesMenuItem.module.scss";

/**
 * The account dropdown's "Pending invites" entry (ART-239) — rendered ONLY when there are any (product owner,
 * 2026-10-08), so the menu never carries a door onto an empty list. Shared by every shell's `AccountMenu`, so
 * the rule and the count are written once. Opens the root-mounted Pending invites modal.
 */
export function PendingInvitesMenuItem() {
  const invites = useMyInvites();
  const count = invites.data?.items?.length ?? 0;
  if (count === 0) return null;
  return (
    <AccountMenuItem onSelect={openPendingInvites}>
      <span className={styles.item}>
        Pending invites
        <span className={styles.count}>{count}</span>
      </span>
    </AccountMenuItem>
  );
}
